export const createQuote = async (baseUrl: string, requestBody: object) => {
  const url = `${baseUrl}/api/v1/trade-in/quotes`;
  return await fetch(url, {
    method: "POST",
    credentials: "omit",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestBody),
  })
    .then(async function (response: Response) {
      const { status } = response;
      if (response.ok && (status >= 200 || status <= 299)) {
        return { status: status, body: await response.json() };
      }
      return { status: status, error: "Trade in create quote failed" };
    })
    .catch(() => {
      return { status: 400, error: "Trade in create quote failed" };
    });
};
